<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..."
  type="ball-scale-multiple">
</ngx-spinner>
<app-header></app-header>
<section>
  <div class="title">{{'Delivery Point mapping with Plant Name' | translate}}</div>
</section>
<section class="supplier_fuso_tabs mt10">
  <section class="part_search_bar row d-flex align-items-center">
    <div class="col-md-6 search input-group">
        <input placeholder="{{'Search by Delivery Point' | translate}}" 
               class="form-control" [(ngModel)]="searchText" />
    </div>
    <div class="offset-md-1 col-md-4 d-flex justify-content-end">
        <button class="table-title btn btn-dark" (click)="exportCSV()">
            {{'Export Available Delivery Point' | translate}}
        </button>
    </div>
</section>

  <section class="parts_container mar-btm-30">
    <div class="row">
      <div class="col-md-5">
        <div class="row_title mar-top-80">{{'Available Delivery Point' | translate}} </div>
      <!-- <p-dataTable [value]="DPData | filter : searchText" [responsive]="true" [rows]="50" [paginator]="true"
          [pageLinks]="3" [rowsPerPageOptions]="[50,100,500,1000]" [paginatorPosition]="'top'" class="" emptyMessage="{{'No Records Found' | translate}}">
          
		  <p-column field="deliveryPoint" header="{{'DELIVERYPOINT' | translate}}" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'Search Next Process' | translate}}">
          </p-column>
		  
          <p-column header="{{'Plant Name' | translate}}" field="plantName" [sortable]="true" [filter]="true"
            filterPlaceholder="{{'Search Plant' | translate}}">
            <ng-template let-row="rowData" pTemplate="body">
              <input list="plantNameList" type="text" class="form-control" name="plantName" value="{{row.plantName}}" />
              <datalist id="plantNameList">
                <option value="Atsugi"></option>
                <option value="CC Yokohama"></option>
                <option value="HO"></option>
                <option value="K1"></option>
                <option value="K2"></option>
                <option value="MFBM"></option>
                <option value="Nakatsu"></option>
                <option value="Resale_Direct"></option>
                <option value="Resale_K2"></option>
                <option value="TAA_HQ"></option>
              </datalist>
            </ng-template>
          </p-column>
        </p-dataTable> -->
        <p-table [value]="DPData | filter : searchText" [responsive]="true" [rows]="50" [paginator]="true"
          [pageLinks]="3" [rowsPerPageOptions]="[50,100,500,1000]" [paginatorPosition]="'top'" class="">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="deliveryPoint" style="width:20%">{{'DELIVERYPOINT' | translate}}<p-sortIcon
                  field="deliveryPoint"></p-sortIcon>
              </th>
              <th pSortableColumn="plantName" style="width:20%">{{'Plant Name' | translate}}<p-sortIcon
                  field="plantName"></p-sortIcon>
              </th>
            </tr>
            <tr>
              <th>
                <p-columnFilter type="text" field="deliveryPoint"></p-columnFilter>
              </th>
              <th>
                <p-columnFilter type="text" field="plantName"></p-columnFilter>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-value>
            <tr>
                <td>
                    {{ value.deliveryPoint }}
                </td>
                <td>
                  <input list="plantNameList" type="text" class="form-control" name="plantName" value="{{value.plantName}}" />
                  <datalist id="plantNameList">
                    <!--[if IE 9]><select disabled style="display:none"><![endif]-->
                    <!-- <option *ngFor="let opt of packageMaterialOpt" [value]=opt> -->
                    <option value="Atsugi"></option>
                    <option value="CC Yokohama"></option>
                    <option value="HO"></option>
                    <option value="K1"></option>
                    <option value="K2"></option>
                    <option value="MFBM"></option>
                    <option value="Nakatsu"></option>
                    <option value="Resale_Direct"></option>
                    <option value="Resale_K2"></option>
                    <option value="TAA_HQ"></option>
                    <!--[if IE 9]></select><![endif]-->
                  </datalist>
                </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td>{{'No Records Found' | translate}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="offset-md-2 col-md-5">
        <div class="row_title">{{'Unlisted Delivery Point' | translate}}</div>

        <div class="col-md-12 search_input input-group custom-search-form pad-top-30" >
          <input type="text" class="form-control"  class="form-control"
            placeholder="{{'Filter by Plant Name' | translate}}" [(ngModel)]="deliverypoint">
          <span class="input-group-btn">
            <button class="btn btn-light" type="button" (click)="onChangeTable(config)">
              {{'Search' | translate}}
            </button>
          </span>
        </div>
        <!-- <pagination *ngIf="config.paging" class="pagination-sm pull-right pad-top-10" [(ngModel)]="page" [totalItems]="length"
          [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)"
          (numPages)="numPages = $event">
        </pagination> -->

        <!-- <ng-table [config]="config" *ngIf="config.filtering" [ngTableFiltering]="config.filtering" (tableChanged)="onChangeTable(config)"
          [rows]="rows" [columns]="columns" (cellClicked)="confirmUnlistAdd(confirmAdd, $event)">
        </ng-table> -->

        
          <pagination *ngIf="config.paging" class="pad-top-10"  [(ngModel)]="page" [totalItems]="length"
          [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)"
          (numPages)="numPages = $event">
        </pagination>
        
        <div class="example-container mat-elevation-z8">
        
          <mat-table [dataSource]="dataSource" >
        
            <ng-container matColumnDef="deliveryPoint">
              <mat-header-cell *matHeaderCellDef > Delivery Point </mat-header-cell>
              <mat-cell *matCellDef="let row">  {{row.deliveryPoint}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="unlisted">
              <mat-header-cell *matHeaderCellDef > Unlisted </mat-header-cell>
              <mat-cell *matCellDef="let row"  ><i class="fa fa-plus-circle" aria-hidden="true" >&nbsp;</i> Add Delivery Point  </mat-cell>
            </ng-container>
        
        
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="confirmUnlistAdd(confirmAdd, row)" >
            </mat-row>
          </mat-table>
        
         
         
        </div>

        
        
        <!-- *ngIf="config.filtering" placeholder="Search by Delivery Point" [ngTableFiltering]="config.filtering" class="form-control" -->
        <!-- (tableChanged)="onChangeTable(config)" -->
      </div>
    </div>
  </section>
</section>
<ng-template #confirmAdd let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Please Select Plant Name relevant to Delivery Point</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <label for="deliveryPoint" class="col-form-label">{{'Delivery_Point' | translate}}</label>
    <input type="text" class="form-control" name="delPoint" [(ngModel)]="toListDelPoint" disabled />
    <label for="plantName" class="col-sm-6 col-form-label">{{'Plant Name' | translate}}</label>
    <input list="plantNameList" type="text" class="form-control" name="plantName" [(ngModel)]="plantNameAddition" />
    <datalist id="plantNameList">
      <!--[if IE 9]><select disabled style="display:none"><![endif]-->
      <option value="Atsugi"></option>
      <option value="CC Yokohama"></option>
      <option value="HO"></option>
      <option value="K1"></option>
      <option value="K2"></option>
      <option value="MFBM"></option>
      <option value="Nakatsu"></option>
      <option value="Resale_Direct"></option>
      <option value="Resale_K2"></option>
      <option value="TAA_HQ"></option>
      <!--[if IE 9]></select><![endif]-->
    </datalist>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-dark" (click)="saveChanges(toListDelPoint, plantNameAddition)">{{'Yes' |
      translate}}</button>
    <button type="button" class="btn btn-dark-brd" (click)="c('Close click')">{{'No' | translate}}</button>
  </div>
</ng-template>